import { AxiosError } from 'axios';
import { f7 } from 'framework7-react';
import { useEffect, useState } from 'react';
import { fetchUserActionCategories } from '@/api/serviceApi';
import {
  FetchUserActionCategoriesParams,
  FetchUserActionCategoriesResponse,
} from '@/types/api/serviceApi';

export const useFetchUserActionCategories = ({
  m_affiliate_id,
}: FetchUserActionCategoriesParams) => {
  const [data, setData] = useState<FetchUserActionCategoriesResponse['data']>();
  const [userActionCategories, setUserActionCategories] =
    useState<
      FetchUserActionCategoriesResponse['data']['m_user_action_categories']
    >();
  const [error, setError] = useState<AxiosError>();

  useEffect(() => {
    f7.preloader.show();

    const fn = async () => {
      try {
        const res = await fetchUserActionCategories({ m_affiliate_id });
        const data = res.data;

        const userActionCategoriesData = data.m_user_action_categories;

        setData(data);
        setUserActionCategories(userActionCategoriesData);
      } catch (err) {
        setError(err as AxiosError);
      } finally {
        f7.preloader.hide();
      }
    };

    fn();
  }, [m_affiliate_id]);

  return {
    data,
    error,
    userActionCategories,
  };
};
